import { FC, useEffect } from 'react';
import { isNil } from 'lodash';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { usePendingDecisionsByFirm } from 'services/hooks';
import { getObjectValue } from 'utilities';

const FirmPendingDecisions: FC = () => {
  const [storeValue] = useStore() as UseStoreValues;
  const { firmInfo: currentFirm } = getObjectValue(storeValue);
  const { id: currentFirmId } = getObjectValue(currentFirm);

  const {
    decisions: pendingDecisions,
    displayDecisionAlerts: displayPendingDecisions,
    fetchPendingDecisions,
    getDisconnectDialog: displayDisconnectCompGroupsDialog,
    isFetchingDecisions,
  } = usePendingDecisionsByFirm();

  // Get pending decisions
  useEffect(() => {
    if (!isNil(currentFirmId) && isNil(pendingDecisions) && !isFetchingDecisions) {
      fetchPendingDecisions?.(currentFirmId);
    }
  }, [currentFirmId, fetchPendingDecisions, isFetchingDecisions, pendingDecisions]);

  return (
    <>
      {/* Pending decisions message */}
      {displayPendingDecisions?.()}
      {/* Disconnect comp groups dialog */}
      {displayDisconnectCompGroupsDialog?.()}
    </>
  );
};

export default FirmPendingDecisions;
